<template>
    <div style="background:#FAFAFA;" class="policeLato">
        <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
        <section v-if="isDesktop()">
            <div class="mt-5 pt-5 paralax-cover-image has-background-dim">
                <p class="paralax-cover-image-text">
                <div class="content_home" style="z-index: 1!important;">
                    <h1 style="font-size: 70px" class="font-weight-bold"><span style="color: #fff">{{ $t('devis.devis_vie.sunuassur.header_title[0]') }}</span></h1>
                    <h1 style="font-size: 70px;margin-top: -30px" class="font-weight-bold"><span style="color: #ffa409" class="ml-1">{{ $t('devis.devis_vie.sunuassur.header_title[1]') }}</span></h1>
                </div>
                </p>
            </div>
        </section>

        <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
        <section class="mt-5" v-if="isMobile()">
            <div class="paralax-cover-image_mobile has-background-dim_mobile">
                <p class="paralax-cover-image-text_mobile">
                <div class="content_home" style="z-index: 1!important;margin-top: 10%">
                    <h1 style="font-size: 40px" class="font-weight-bold"><span style="color: #fff">{{ $t('devis.devis_vie.sunuassur.header_title[0]') }}</span></h1>
                    <h1 style="font-size: 40px;margin-top: -20px;color: #ffa409" class="font-weight-bold"><span>{{ $t('devis.devis_vie.sunuassur.header_title[1]') }}</span></h1>
                </div>
                </p>
            </div>
        </section>
        <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
        <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
        <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
        <!-- ========================================================================================= -->
        <div>
            <div class="container" style="background:#FAFAFA">
                <div class="container justify-content-center row text-center mb-5 mt-5">
                    <p class="mb-3" style="font-weight: 300;color: #ffa409;font-family: Open Sans, sans-serif;font-size:25px!important;">{{ $t('devis.devis_vie.sunuassur.title[0]') }} <span class="font-weight-bold">{{ $t('devis.devis_vie.sunuassur.title[1]') }}</span>{{ $t('devis.devis_vie.sunuassur.title[2]') }} <span class="font-weight-bold">{{ $t('devis.devis_vie.sunuassur.title[3]') }}</span></p> <br>
                </div>
                <br>
                
                <div class="row" style="background:#FAFAFA" v-if="isDesktop()">
                    <div class="col-md-10 offset-1" style="background:#FAFAFA">
                        <div class="form" style="background:#FAFAFA">
                            <div class="wizard-navigation">
                                <div class="wizard-progress-with-circle">
                                    <div class="wizard-progress-bar" style="background-color: rgb(231, 76, 60); color: rgb(231, 76, 60); width: 4.54545%;"></div>
                                </div>
                                <div class="progress-bar-group">
                                    <div class="progress-bar-custom" id="testup"></div>
                                </div>
                                <ul role="tablist" class="wizard-nav wizard-nav-pills">
                                    <li class="step" id="firstStep">
                                        <div class="step-title">{{ $t('devis.devis_vie.sunuassur.stepper_title[0]') }}</div>
                                    </li>
                                    <li class="step" id="secondStep">
                                        <div class="step-title">{{ $t('devis.devis_vie.sunuassur.stepper_title[1]') }}</div>
                                    </li>
                                  <li class="step" id="thirtStep">
                                    <div class="step-title">{{ $t('devis.devis_vie.sunuassur.stepper_title[3]') }}</div>
                                  </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row" style="background:#FAFAFA" v-if="isMobile()">
                    <div class="col-md-10" style="background:#FAFAFA">
                        <div class="form" style="background:#FAFAFA">
                            <div class="wizard-navigation">
                            <div class="wizard-progress-with-circle">
                                <div class="wizard-progress-bar" style="background-color: rgb(231, 76, 60); color: rgb(231, 76, 60); width: 4.54545%;"></div>
                            </div>
                            <div class="progress-bar-group">
                                <div class="progress-bar-custom" id="testup"></div>
                            </div>
                            <ul role="tablist" class="wizard-nav wizard-nav-pills">
                                <li class="step" id="firstStep">
                                    <div class="step-title text-center mr-4">{{ $t('devis.devis_vie.sunuassur.stepper_title[0]') }}</div>
                                </li>
                                <li class="step" id="secondStep">
                                    <div class="step-title text-center mr-4">{{ $t('devis.devis_vie.sunuassur.stepper_title[1]') }}</div>
                                </li>
                              <li class="step" id="thirtStep">
                                <div class="step-title text-center mr-4">{{ $t('devis.devis_vie.sunuassur.stepper_title[3]') }}</div>
                              </li>
                            </ul>
                        </div>
                        </div>
                    </div>
                </div>

                <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP     =============== -->
                <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
                <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
                <!-- ========================================================================================= -->
                <div v-responsive.lg.xl class="row mt-5" style="background:#FAFAFA">
                    <div class="col-md-10 offset-1" style="background:#FAFAFA">
                        <div class="form" style="background:#FAFAFA">                           
                            <div class="page" v-show="step === 1">
                               <div class="wizard-tab-content">
                                    <div role="tabpanel" id="StepSimule" aria-hidden="true" aria-labelledby="step-StepSimule" class="wizard-tab-container">

                                        <div>
                                            <div class="loan-group loan-group-0">
                                                <div class="fields">
                                                <div class="field-title font-weight-bold">{{ $t('devis.devis_vie.sunuassur.firstStep.titre_stepr_1') }}&nbsp;:</div>
                                                <div class="row">
                                                <div class="col-sm-6">
                                                    <div class="field-group field-default">
                                                    <label for="date_naissance_assure" class="field-label">
                                                        {{ $t('devis.devis_vie.sunuassur.firstStep.date_naissance_assure_label') }}
                                                        <!---->
                                                    </label>
                                                    <div class="input-group value-loan">
                                                        <date-picker class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_vie.sunuassur.firstStep.date_naissance_placeholder')" id="date_naissance_assure" @change="yearsDiff()" v-model="dateNaiss" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                    </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm-6">
                                                    <div class="field-group field-default">
                                                    <label for="date_naissance_benef" class="field-label">
                                                        {{$t('devis.devis_vie.sunuassur.firstStep.date_naissance_beneficiaire_label')}}
                                                        <!---->
                                                    </label>
                                                    <div class="input-group value-loan">
                                                        <date-picker class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_vie.sunuassur.firstStep.date_naissance_placeholder')" id="date_naissance_benef" @change="yearsDiffBenef()" v-model="Assurhospi.Beneficiaire.dateNaissance" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                    </div>
                                                    </div>
                                                </div>
                                                </div>
                                            </div>
                                                <div class="fields">
                                                    <div class="row">
                                                        <div class="col-sm-6">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="montant_formule" class="field-label">{{$t('devis.devis_vie.sunuassur.firstStep.selection_formule_label')}}</label>
                                                                <select @change="setFormuleCapitaux()" id="montant_formule" v-model="Assurhospi.capital" name="Step8" class="field-select">
                                                                    <option selected disabled>{{$t('devis.devis_vie.sunuassur.firstStep.selection_formule_label')}}</option>
                                                                    <option v-for="(items, idx) in listecapitaux" :key="idx" :value="items.capital">{{items.capital.toLocaleString() + " FCFA"}}</option>
                                                                </select>
                                                            </div>
                                                        </div>

                                                        <div class="col-sm-6">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="duree_capital" class="field-label">{{$t('devis.devis_vie.sunuassur.firstStep.duree_mois_label')}}</label>
                                                                <select @change="setFormuleDureeCapitaux()" v-model="Assurhospi.duree" id="duree_capital" name="Step8" class="field-select">
                                                                    <option selected disabled>{{$t('devis.devis_vie.sunuassur.firstStep.duree_mois_placeholder')}}</option>
                                                                    <option v-for="items in nbmois" :key="items" :value="items">{{items}}</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="fields" >
                                                    <div class="row">
                                                        <div class="col-sm-12" v-if="Assurhospi.capital != null">
                                                            <div class="field-group field-default">
                                                            <ul class="to-left mb-3 mr-3 policeLato">
                                                                <li class="subheading" style="list-style: none">{{$t('devis.devis_vie.sunuassur.firstStep.capital_deces_label')}} :
                                                                    <span style="color:#ffa409" class="font-weight-bold to-right" v-if="this.Assurhospi.capital != null">{{Assurhospi.capital.toLocaleString()}} FCFA</span>
                                                                </li>

                                                                <li class="subheading" style="list-style: none">{{$t('devis.devis_vie.sunuassur.firstStep.couverture_desktop_label')}} :
                                                                    <span style="color:#ffa409" class="font-weight-bold to-right" v-if="Assurhospi.hospitalisation != null">{{Assurhospi.hospitalisation.toLocaleString()}} FCFA</span>
                                                                </li>

                                                                <li class="subheading" style="list-style: none">{{$t('devis.devis_vie.sunuassur.firstStep.prime_total')}} :
                                                                    <span style="color:#ffa409" class="font-weight-bold to-right" v-if="this.Assurhospi.prime != null">{{Assurhospi.prime.toLocaleString()}} FCFA</span>
                                                                </li>
                                                            </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="wizard-card-footer clearfix mb-5">
                                                <div class="wizard-footer-left">
                                                </div>
                                                <div class="wizard-footer-right">
                                                    <button @click="DevisNextStep()" type="button" class="wizard-btn">
                                                        {{ $t('devis.devis_vie.sunuassur.bouton_suivant_label') }}
                                                    </button>
                                                </div>
                                                <!---->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="page" v-show="step === 2">
                               <div class="wizard-tab-content">
                                    <div role="tabpanel" id="StepContractant" aria-hidden="true" aria-labelledby="step-StepContractant" class="wizard-tab-container">
                                        <div v-if="isContractant">
                                            <div class="loan-group loan-group-0">
                                                <div class="fields">
                                                    <div class="field-title font-weight-bold">{{ $t('devis.devis_vie.sunuassur.secondStep.title') }}&nbsp;:</div>
                                                    <div class="justify-content-center row">
                                                        <div class="col-sm-12 field-radio field-radio-center">
                                                            <div class="btn-choice">
                                                                <input v-model="Assurhospi.Contractant.Genre" value="homme" type="radio" id="monsieur" name="genre" class="field-input">
                                                                <label for="monsieur" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.monsieur_label') }}</label>
                                                            </div>
                                                            <div class="btn-choice">
                                                                <input v-model="Assurhospi.Contractant.Genre" value="femme" type="radio" id="madame" name="genre" class="field-input" >
                                                                <label for="madame" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.madame_label') }}</label>
                                                            </div>
                                                            <div class="btn-choice">
                                                                <input v-model="Assurhospi.Contractant.Genre" value="entreprise" type="radio" id="entreprise" name="genre" class="field-input" >
                                                                <label for="entreprise" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.entreprise_label') }}</label>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="justify-content-center row mt-5">
                                                        <div class="col-sm-12 field-radio field-radio-center">
                                                            <div class="btn-choice">
                                                                <input v-model="Assurhospi.Contractant.Situation" value="marié" type="radio" id="marie" name="situation" class="field-input" >
                                                                <label for="marie" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.marie_label') }}</label>
                                                            </div>
                                                            <div class="btn-choice">
                                                                <input v-model="Assurhospi.Contractant.Situation" value="célibataire" type="radio" id="celibat" name="situation" class="field-input" >
                                                                <label for="celibat" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.celibat_label') }}</label>
                                                            </div>
                                                            <div class="btn-choice">
                                                                <input v-model="Assurhospi.Contractant.Situation" value="veuf" type="radio" id="veuf" name="situation" class="field-input" >
                                                                <label for="veuf" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.veuf_label') }}</label>
                                                            </div>
                                                            <div class="btn-choice">
                                                                <input v-model="Assurhospi.Contractant.Situation" value="divorce" type="radio" id="divorce" name="situation" class="field-input" >
                                                                <label for="divorce" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.divorce_label') }}</label>
                                                            </div>
                                                        </div>
                                                    
                                                    </div>
                                                </div>

                                                <div class="fields">
                                                    <div class="row">
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="nom_contractant" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.nom_label') }}</label>
                                                                <input v-model="Assurhospi.Contractant.Nom" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.contractant_form.nom_placeholder')" id="nom_contractant" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="prenom_contractant" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.prenom_label') }}</label>
                                                                <input v-model="Assurhospi.Contractant.Prenom" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.contractant_form.prenom_placeholder')" id="prenom_contractant" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default">
                                                                <label for="date_naiss_contractant" class="field-label">
                                                                    {{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.date_naissance_label') }}
                                                                    <!---->
                                                                </label>
                                                                <div class="input-group value-loan">
                                                                    <date-picker class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.contractant_form.date_naissance_placeholder')" id="date_naiss_contractant" @change="yearsDiffContractant()" v-model="Assurhospi.Contractant.dateNaissance" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="fields">
                                                    <div class="row">
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="lieu_naiss_contractant" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.lieu_naissance_label') }}</label>
                                                                <input v-model="Assurhospi.Contractant.LieuNaissance" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.contractant_form.lieu_naissance_placeholder')" id="lieu_naiss_contractant" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="profession_contractant" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.profession_label') }}</label>
                                                                <input v-model="Assurhospi.Contractant.Profession" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.contractant_form.profession_placeholder')" id="profession_contractant" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="adresse_contractant" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.adresse_label') }}</label>
                                                                <input v-model="Assurhospi.Contractant.Adresse" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.contractant_form.adresse_placeholder')" id="adresse_contractant" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="fields">
                                                    <div class="row">
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="telephone_contractant" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.telephone_label') }}</label>
                                                                <input @keypress="onlyNumber" v-model="Assurhospi.Contractant.Telephone" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.contractant_form.telephone_placeholder')" id="telephone_contractant" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="email_contractant" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.email_label') }}</label>
                                                                <input v-model="Assurhospi.Contractant.Email" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.contractant_form.email_placeholder')" id="email_contractant" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="cni_contractant" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.cni_label') }}</label>
                                                                <input @keypress="onlyNumber" v-model="Assurhospi.Contractant.Cni" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.contractant_form.cni_placeholder')" id="cni_contractant" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="wizard-card-footer clearfix mb-5">
                                                <div class="wizard-footer-left">
                                                    <button @click="returToFirstStep()" type="button" class="wizard-btn">
                                                    <span class="fas fa-arrow-left"></span>
                                                    {{$t('devis.devis_vie.sunuassur.bouton_retour_label')}}
                                                    </button>
                                                </div>
                                                <div class="wizard-footer-right">
                                                    <button v-if="activeStep + 1 < formSteps.length -1" @click="ContractControl()" type="button" class="wizard-btn">
                                                    {{$t('devis.devis_vie.sunuassur.bouton_suivant_label')}}
                                                    </button>
                                                </div>
                                                <!---->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="page" v-show="step === 3">
                               <div class="wizard-tab-content">
                                    <div role="tabpanel" id="StepAssure" aria-hidden="true" aria-labelledby="step-StepAssure" class="wizard-tab-container">
                                        <div v-if="isAssure">
                                            <div class="loan-group loan-group-0"> 
                                                <div class="fields">
                                                    <div class="field-title font-weight-bold">{{ $t('devis.devis_vie.sunuassur.secondStep.assure_title') }}&nbsp;:</div>
                                                    <div class="row">
                                                        <div class="col-sm-12">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <div class="field-checkbox">
                                                                <div class="switch">
                                                                    <label for="assur_question"><span class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.question_assure_title') }}</span>
                                                                    <input style="margin-top:5px" @change="toggleCheckbox()" v-model="checkbox" type="checkbox" id="assur_question" name="Step12">
                                                                    <span style="margin-top: 5px;" class="lever"></span>
                                                                    </label>
                                                                </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="fields">
                                                    <div class="row">
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="nom_assure" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.assure_form.nom_label') }} *</label>
                                                                <input :disabled="this.checkbox == true" v-model="Assurhospi.Assure.Nom" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.assure_form.nom_placeholder')" id="nom_assure" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="prenom_assure" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.assure_form.prenom_label') }} *</label>
                                                                <input :disabled="this.checkbox == true" v-model="Assurhospi.Assure.Prenom" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.assure_form.prenom_placeholder')" id="prenom_assure" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default">
                                                                <label for="date_naiss_assure" class="field-label">
                                                                    {{ $t('devis.devis_vie.sunuassur.secondStep.assure_form.date_naissance_label') }} *
                                                                    <!---->
                                                                </label>
                                                                <div class="input-group value-loan">
                                                                    <date-picker disabled class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.assure_form.date_naissance_placeholder')" id="date_naiss_assure" @change="yearsDiffAssure()" v-model="Assurhospi.Assure.dateNaissance" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="fields">
                                                    <div class="row">
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="lieu_naiss_assure" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.assure_form.lieu_naissance_label') }} *</label>
                                                                <input :disabled="this.checkbox == true" v-model="Assurhospi.Assure.LieuNaissance" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.assure_form.lieu_naissance_placeholder')" id="lieu_naiss_assure" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="profession_assure" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.assure_form.profession_label') }} *</label>
                                                                <input :disabled="this.checkbox == true" v-model="Assurhospi.Assure.Profession" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.assure_form.profession_placeholder')" id="profession_assure" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="adresse_assure" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.assure_form.adresse_label') }} *</label>
                                                                <input :disabled="this.checkbox == true" v-model="Assurhospi.Assure.Adresse" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.assure_form.adresse_placeholder')" id="adresse_assure" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="fields">
                                                    <div class="row">
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="telephone_assure" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.assure_form.telephone_label') }} *</label>
                                                                <input :disabled="this.checkbox == true" v-model="Assurhospi.Assure.Telephone" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.assure_form.telephone_placeholder')" id="telephone_assure" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="email_assure" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.assure_form.email_label') }} *</label>
                                                                <input :disabled="this.checkbox == true" v-model="Assurhospi.Assure.Email" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.assure_form.email_placeholder')" id="email_assure" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="lieu_exercice_assure" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.assure_form.lieu_exercice_label') }} *</label>
                                                                <input v-model="Assurhospi.Assure.LieuExe" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.assure_form.lieu_exercice_placeholder')" id="lieu_exercice_assure" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="fields">
                                                    <div class="row">
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="telephone_assure" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.assure_form.cni_label') }} *</label>
                                                                <input @keypress="onlyNumber" v-model="Assurhospi.Assure.Cni" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.assure_form.cni_placeholder')" id="telephone_assure" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="wizard-card-footer clearfix mb-5">
                                                <div class="wizard-footer-left">
                                                    <button @click="returToSecondStep()" type="button" class="wizard-btn">
                                                    <span class="fas fa-arrow-left"></span>
                                                    {{$t('devis.devis_vie.sunuassur.bouton_retour_label')}}
                                                    </button>
                                                </div>
                                                <div class="wizard-footer-right">
                                                    <button @click="AssureControl()" type="button" class="wizard-btn">
                                                    {{$t('devis.devis_vie.sunuassur.bouton_suivant_label')}}
                                                    </button>
                                                </div>
                                                <!---->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="page" v-show="step === 4">
                               <div class="wizard-tab-content">
                                    <div role="tabpanel" id="StepBenef" aria-hidden="true" aria-labelledby="step-StepBenef" class="wizard-tab-container">
                                        <div v-if="isBenef">
                                            <div class="loan-group loan-group-0"> 
                                                <div class="fields">
                                                    <div class="field-title font-weight-bold">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_title') }}&nbsp;:</div>
                                                    <div class="row">
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="nom_benef" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.nom_label') }} *</label>
                                                                <input v-model="Assurhospi.Beneficiaire.Nom" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.benef_form.nom_placeholder')" id="nom_benef" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="prenom_benef" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.prenom_label') }} *</label>
                                                                <input v-model="Assurhospi.Beneficiaire.Prenom" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.benef_form.prenom_placeholder')" id="prenom_benef" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="cni_benef" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.cni_label') }} *</label>
                                                                <input @keypress="onlyNumber" v-model="Assurhospi.Beneficiaire.Cni" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.benef_form.cni_placeholder')" id="cni_benef" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="fields">
                                                    <div class="row">
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default">
                                                                <label for="date_naiss_benef" class="field-label">
                                                                    {{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.date_naissance_label') }}
                                                                    <!---->
                                                                </label>
                                                                <div class="input-group value-loan">
                                                                    <date-picker disabled class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.benef_form.date_naissance_placeholder')" id="date_naiss_benef" @change="yearsDiffBenef()" v-model="Assurhospi.Beneficiaire.dateNaissance" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="lieu_naiss_benef" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.lieu_naissance_label') }}</label>
                                                                <input v-model="Assurhospi.Beneficiaire.LieuNaissance" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.benef_form.lieu_naissance_placeholder')" id="lieu_naiss_benef" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="filiation_benef" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.filiation_label') }}</label>
                                                                <select v-model="Assurhospi.Beneficiaire.Filiation" id="filiation_benef" name="Step8" class="field-select">
                                                                    <option></option>
                                                                    <option value="pere_mere">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.filiation_hospi_select.pere_mere') }}</option>
                                                                    <option value="fils_fille">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.filiation_hospi_select.fils_fille') }}</option>
                                                                    <option value="frere_soeur">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.filiation_hospi_select.frere_soeur') }}</option>
                                                                    <option value="epoux_epouse">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.filiation_hospi_select.epoux_epouse') }}</option>
                                                                    <option value="autres">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.filiation_hospi_select.autre_label') }}</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="wizard-card-footer clearfix mb-5">
                                                <div class="wizard-footer-left">
                                                    <button @click="returToThirstStep()" type="button" class="wizard-btn">
                                                    <span class="fas fa-arrow-left"></span>
                                                    {{$t('devis.devis_vie.sunuassur.bouton_retour_label')}}
                                                    </button>
                                                </div>
                                                <div class="wizard-footer-right">
                                                    <button @click="BenefControl()" type="button" class="wizard-btn">
                                                    {{$t('devis.devis_vie.sunuassur.bouton_suivant_label')}}
                                                    </button>
                                                </div>
                                                <!---->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="page" v-show="step === 5">
                                <div class="wizard-tab-content">
                                <div role="tabpanel" id="StepRecap" aria-labelledby="step-StepRecap" class="wizard-tab-container">
                                    <div>
                                    <div class="fields">
                                        <section class="section-sm-bottom-85">
                                        <div class="container mt-1">
                                            <div class="row gx-xxl-6">
                                            <div class="col-12 col-lg-12">
                                                <div class="row">
                                                <div class="col-12">
                                                    <div class="post">
                                                    <div class="post-body">
                                                        <div>
                                                        <div class="articleContent s-post page-h2 page-h3" style="margin-top:60px;border-radius: 15px!important;box-shadow: 9px 12px 18px rgba(0, 0, 0, .2)">
                                                            <div class="form">
                                                            <div class="page">
                                                                <div class="wizard-tab-content">
                                                                <div role="tabpanel" id="Step1" aria-labelledby="step-Step1" class="wizard-tab-container">
                                                                    <div class="field-title font-weight-bold">{{ $t('devis.devis_vie.sunuassur.validationStep.title') }} :</div>
                                                                    <div class="mt-3 justify-content-center row">
                                                                    <div class="justify-content-center row">
                                                                        <p class="font-weight-bold field-title" style="color: #ffa409">{{ $t('devis.devis_vie.sunuassur.validationStep.contractant.title') }}</p>
                                                                    </div>
                                                                    </div>
                                                                    <div class="row" style="margin-top: -10px !important;background: #fafafa;border-radius: 12px;box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1);">
                                                                    <div class="col-sm-12">
                                                                        <div class="field-group field-default">
                                                                        <ul class="to-left mb-3 mr-3 policeLato">
                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.contractant.genre_label') }} :
                                                                                <span v-if="Assurhospi.Contractant.Genre == 'homme'" class="font-weight-bold to-right">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.monsieur_label') }}</span>
                                                                                <span v-if="Assurhospi.Contractant.Genre == 'femme'" class="font-weight-bold to-right">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.madame_label') }}</span>
                                                                            </li>

                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.contractant.situation_label') }} :
                                                                                <span v-if="Assurhospi.Contractant.Situation == 'marié'" class="font-weight-bold to-right">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.marie_label') }}</span>
                                                                                <span v-if="Assurhospi.Contractant.Situation == 'célibataire'" class="font-weight-bold to-right">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.celibat_label') }}</span>
                                                                                <span v-if="Assurhospi.Contractant.Situation == 'veuf'" class="font-weight-bold to-right">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.veuf_label') }}</span>
                                                                                <span v-if="Assurhospi.Contractant.Situation == 'divorce'" class="font-weight-bold to-right">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.divorce_label') }}</span>
                                                                            </li>

                                                                            <li  class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.contractant.nom_label') }} :
                                                                            <span class="font-weight-bold to-right">{{Assurhospi.Contractant.Nom}}</span>
                                                                            </li>

                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.contractant.prenom_label') }} :
                                                                            <span class="font-weight-bold to-right">{{Assurhospi.Contractant.Prenom}}</span>
                                                                            </li>

                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.contractant.date_naissance_label') }} :
                                                                            <span class="font-weight-bold to-right">{{DateFormater(Assurhospi.Contractant.dateNaissance)}}</span>
                                                                            </li>

                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.contractant.lieu_naissance_label') }} :
                                                                            <span class="font-weight-bold to-right">{{Assurhospi.Contractant.LieuNaissance}}</span>
                                                                            </li>

                                                                            <li  class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.contractant.profession_label') }} :
                                                                            <span class="font-weight-bold to-right">{{Assurhospi.Contractant.Profession}}</span>
                                                                            </li>

                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.contractant.adresse_label') }} :
                                                                            <span class="font-weight-bold to-right">{{Assurhospi.Contractant.Adresse}}</span>
                                                                            </li>

                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.contractant.telephone_label') }} :
                                                                            <span class="font-weight-bold to-right">{{Assurhospi.Contractant.Telephone}}</span>
                                                                            </li>

                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.contractant.email_label') }} :
                                                                            <span class="font-weight-bold to-right">{{Assurhospi.Contractant.Email}}</span>
                                                                            </li>
                                                                        </ul>
                                                                        </div>
                                                                    </div>
                                                                    </div>

                                                                    <div class="mt-3 justify-content-center row">
                                                                    <div class="justify-content-center row">
                                                                        <p class="font-weight-bold field-title" style="color: #ffa409">{{ $t('devis.devis_vie.sunuassur.validationStep.assure.title') }}</p>
                                                                    </div>
                                                                    </div>
                                                                    <div class="row" style="margin-top: -10px !important;background: #fafafa;border-radius: 12px;box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1);">
                                                                    <div class="col-sm-12">
                                                                        <div class="field-group field-default">
                                                                        <ul class="to-left mb-3 mr-3 policeLato">
                                                                            <li  class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.assure.nom_label') }} :
                                                                            <span class="font-weight-bold to-right">{{Assurhospi.Assure.Nom}}</span>
                                                                            </li>

                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.assure.prenom_label') }} :
                                                                            <span class="font-weight-bold to-right">{{Assurhospi.Assure.Prenom}}</span>
                                                                            </li>

                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.assure.date_naissance_label') }} :
                                                                            <span class="font-weight-bold to-right">{{DateFormater(Assurhospi.Assure.dateNaissance)}}</span>
                                                                            </li>

                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.assure.lieu_naissance_label') }} :
                                                                            <span class="font-weight-bold to-right">{{Assurhospi.Assure.LieuNaissance}}</span>
                                                                            </li>

                                                                            <li  class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.assure.profession_label') }} :
                                                                            <span class="font-weight-bold to-right">{{Assurhospi.Assure.Profession}}</span>
                                                                            </li>

                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.assure.adresse_label') }} :
                                                                            <span class="font-weight-bold to-right">{{Assurhospi.Assure.Adresse}}</span>
                                                                            </li>

                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.assure.telephone_label') }} :
                                                                            <span class="font-weight-bold to-right">{{Assurhospi.Assure.Telephone}}</span>
                                                                            </li>

                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.assure.email_label') }} :
                                                                            <span class="font-weight-bold to-right">{{Assurhospi.Assure.Email}}</span>
                                                                            </li>
                                                                        </ul>
                                                                        </div>
                                                                    </div>
                                                                    </div>

                                                                    <div class="mt-3 justify-content-center row">
                                                                    <div class="justify-content-center row">
                                                                        <p class="font-weight-bold field-title" style="color: #ffa409">{{ $t('devis.devis_vie.sunuassur.validationStep.beneficiaire.title') }}</p>
                                                                    </div>
                                                                    </div>
                                                                    <div class="row" style="margin-top: -10px !important;background: #fafafa;border-radius: 12px;box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1);">
                                                                    <div class="col-sm-12">
                                                                        <div class="field-group field-default">
                                                                        <ul class="to-left mb-3 mr-3 policeLato">
                                                                            <li  class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.beneficiaire.nom_label') }} * :
                                                                            <span class="font-weight-bold to-right">{{Assurhospi.Beneficiaire.Nom}}</span>
                                                                            </li>

                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.beneficiaire.prenom_label') }} * :
                                                                            <span class="font-weight-bold to-right">{{Assurhospi.Beneficiaire.Prenom}}</span>
                                                                            </li>

                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.beneficiaire.date_naissance_label') }} :
                                                                            <span class="font-weight-bold to-right">{{DateFormater(Assurhospi.Beneficiaire.dateNaissance)}}</span>
                                                                            </li>

                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.beneficiaire.lieu_naissance_label') }} :
                                                                            <span class="font-weight-bold to-right">{{Assurhospi.Beneficiaire.LieuNaissance}}</span>
                                                                            </li>

                                                                            <li  class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.beneficiaire.filiation_label') }} :
                                                                                <span v-if="Assurhospi.Beneficiaire.Filiation == 'pere_mere'" class="font-weight-bold to-right">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.filiation_hospi_select.pere_mere') }}</span>
                                                                                <span v-if="Assurhospi.Beneficiaire.Filiation == 'fils_fille'" class="font-weight-bold to-right">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.filiation_hospi_select.fils_fille') }}</span>
                                                                                <span v-if="Assurhospi.Beneficiaire.Filiation == 'frere_soeur'" class="font-weight-bold to-right">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.filiation_hospi_select.frere_soeur') }}</span>
                                                                                <span v-if="Assurhospi.Beneficiaire.Filiation == 'epoux_epouse'" class="font-weight-bold to-right">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.filiation_hospi_select.epoux_epouse') }}</span>
                                                                                <span v-if="Assurhospi.Beneficiaire.Filiation == 'autres'" class="font-weight-bold to-right">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.filiation_hospi_select.autre_label') }}</span>
                                                                            </li>
                                                                        </ul>
                                                                        </div>
                                                                    </div>
                                                                    </div>

                                                                    <div class="mt-3 justify-content-center row">
                                                                    <div class="justify-content-center row">
                                                                        <p class="font-weight-bold field-title" style="color: #ffa409">{{ $t('devis.devis_vie.sunuassur.validationStep.garantie.title') }}</p>
                                                                    </div>
                                                                    </div>

                                                                    <div class="row" style="margin-top: -10px !important;background: #fafafa;border-radius: 12px;box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1);">
                                                                    <div class="col-sm-12">
                                                                        <div class="field-group field-default">
                                                                        <ul class="to-left mb-3 mr-3 policeLato" v-if="Assurhospi.capital != null">
                                                                            <li  class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.garantie.duree_label') }} :
                                                                                <span style="color:#ffa409" class="font-weight-bold to-right">{{Assurhospi.duree}} {{ $t('devis.devis_vie.sunuassur.validationStep.garantie.mois_label') }}</span>
                                                                            </li>

                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.garantie.capital_hospi_label') }} :
                                                                                <span class="font-weight-bold to-right" v-if="Assurhospi.capital != null">{{Assurhospi.capital.toLocaleString()}} FCFA</span>
                                                                            </li>
                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.garantie.prime_mensuel_label') }} :
                                                                                <span style="color:#ffa409" class="font-weight-bold to-right" v-if="this.Assurhospi.prime != null">{{Assurhospi.prime.toLocaleString()}} FCFA</span>
                                                                            </li>

                                                                            <li  class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.garantie.branche_label') }} :
                                                                                <span style="color:#ffa409" class="font-weight-bold to-right">{{Assurhospi.branche}}</span>
                                                                            </li>

                                                                            <li  class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.garantie.assureur_label') }} :
                                                                                <span style="color:#ffa409" class="font-weight-bold to-right">{{Assurhospi.assureur}}</span>
                                                                            </li>
                                                                        </ul>
                                                                        </div>
                                                                    </div>
                                                                    </div>

                                                                    <div class="mt-3 justify-content-center row">
                                                                    <div class="justify-content-center row">
                                                                        <p class="font-weight-bold field-title" style="color: #ffa409">{{ $t('devis.devis_vie.sunuassur.validationStep.periode.title') }}</p>
                                                                    </div>
                                                                    </div>

                                                                    <div class="row">
                                                                    <div class="col-sm-6">
                                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="Stepper39" class="field-label">{{ $t('devis.devis_vie.sunuassur.validationStep.periode.date_effet') }}
                                                                            <button type="button" tabindex="-1" title="" class="field-help" data-original-title="Taux d'intérêt"></button></label>
                                                                        <div class="input-group rate-loan">
                                                                            <date-picker id="Stepper39" :disabled-date="disabledAfterToday"  class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_vie.sunuassur.validationStep.periode.date_effet_placeholder')" @change="dateDiff()" :min="new Date().toISOString().substr(0, 10)" v-model="Assurhospi.dateEffet" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                                        </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-sm-6">
                                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="Stepper40" class="field-label">{{ $t('devis.devis_vie.sunuassur.validationStep.periode.date_echeance') }}
                                                                            <button type="button" tabindex="-1" title="" class="field-help" data-original-title="Taux d'intérêt"></button></label>
                                                                        <div class="input-group rate-loan">
                                                                            <input disabled :placeholder="$t('devis.devis_vie.sunuassur.validationStep.periode.date_echeance_placeholder')" v-model="Assurhospi.dateEcheance" id="Stepper40" name="Step11" class="field-input">
                                                                        </div>
                                                                        </div>
                                                                    </div>
                                                                    </div>
                                                                </div>
                                                                </div>
                                                                <div class="wizard-card-footer clearfix mb-3">
                                                                <div class="wizard-footer-left">
                                                                </div>
                                                                <div class="wizard-footer-right">
                                                                    <button :disabled="disabledButtonValidate" @click="CreateDevis()" type="button" class="wizard-btn">
                                                                        {{ $t('devis.devis_vie.sunuassur.bouton_valider_label') }}
                                                                    </button>
                                                                </div>
                                                                </div>
                                                            </div>
                                                            </div>
                                                        </div>
                                                        </div>
                                                    </div>
                                                    </div>
                                                </div>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                        </section>
                                    </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                 <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE MOBILE     =============== -->
                <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
                <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
                <!-- ========================================================================================= -->
                <div v-responsive.sm.xs>
                    <div class="mt-5" style="background:#FAFAFA">
                    <div class="row" style="background:#FAFAFA">

                        <div class="col-md-10" style="background:#FAFAFA">
                            <div class="form" style="background:#FAFAFA">
                                <div class="page" v-show="step === 1">
                                    <div>
                                        <div class="loan-group loan-group-0" style="z-index:0!important">
                                            <div class="fields">
                                                <div class="field-title font-weight-bold">{{ $t('devis.devis_vie.sunuassur.firstStep.titre_stepr_1') }}&nbsp;:</div>
                                                <div class="row">
                                                    <div class="col-sm-12">
                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                        <label for="date_naissance_assure_mobile" class="field-label">
                                                            {{ $t('devis.devis_vie.sunuassur.firstStep.date_naissance_assure_label') }}
                                                            <!---->
                                                        </label>
                                                        <div class="input-group value-loan">
                                                            <date-picker class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_vie.sunuassur.firstStep.date_naissance_placeholder')" id="date_naissance_assure_mobile" @change="yearsDiff()" v-model="dateNaiss" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                        </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-12">
                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                        <label for="date_naissance_benef_mobile" class="field-label">
                                                            {{$t('devis.devis_vie.sunuassur.firstStep.date_naissance_beneficiaire_label')}}
                                                            <!---->
                                                        </label>
                                                        <div class="input-group value-loan">
                                                            <date-picker class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_vie.sunuassur.firstStep.date_naissance_placeholder')" id="date_naissance_benef_mobile" @change="yearsDiffBenef()" v-model="Assurhospi.Beneficiaire.dateNaissance" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                        </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-12">
                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                            <label for="duree_capital_mobile" class="field-label">{{$t('devis.devis_vie.sunuassur.firstStep.selection_formule_label')}}</label>
                                                            <select @change="setFormuleCapitaux()" v-model="Assurhospi.capital" id="duree_capital_mobile" name="Step8_mobile" class="field-select">
                                                                <option value="null" selected disabled>{{$t('devis.devis_vie.sunuassur.firstStep.selection_formule_label')}}</option>
                                                                <option v-for="(items, idx) in listecapitaux" :key="idx" :value="items.capital">{{items.capital.toLocaleString() + " FCFA"}}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-12">
                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                            <label for="duree_capital_mobile" class="field-label">{{$t('devis.devis_vie.sunuassur.firstStep.duree_mois_label')}}</label>
                                                            <select @change="setFormuleDureeCapitaux()" v-model="Assurhospi.duree" id="duree_capital_mobile" name="Step8_mobile" class="field-select">
                                                                <option value="null" selected disabled>{{$t('devis.devis_vie.sunuassur.firstStep.duree_mois_placeholder')}}</option>
                                                                <option v-for="items in nbmois" :key="items" :value="items">{{items}}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="fields" >
                                                <div class="row">
                                                    <div class="col-sm-12">
                                                        <div class="justify-content-center row" >
                                                            
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>
                                        </div>

                                        <div class="fields">
                                            <div class="field-group row flex-column flex-sm-row">
                                                <div class="justify-content-center row ml-3 mr-3" v-if="Assurhospi.capital !=null">
                                                    <ul class="to-left mb-3 mr-3 policeLato">
                                                        <li class="subheading" style="list-style: none">{{$t('devis.devis_vie.sunuassur.firstStep.capital_deces_label')}} :
                                                        <span style="color:#ffa409" class="font-weight-bold to-right" v-if="Assurhospi.capital != null">{{Assurhospi.capital.toLocaleString()}} FCFA</span>
                                                        </li>
                                                        <li class="subheading" style="list-style: none">{{$t('devis.devis_vie.sunuassur.firstStep.couverture_mobile_label')}} :
                                                        <span style="color:#ffa409" class="font-weight-bold to-right" v-if="this.Assurhospi.hospitalisation != null">{{Assurhospi.hospitalisation.toLocaleString()}} FCFA</span>
                                                        </li>
                                                        <li class="subheading" style="list-style: none">{{$t('devis.devis_vie.sunuassur.firstStep.prime_total')}} :
                                                        <span style="color:#ffa409" class="font-weight-bold to-right" v-if="this.Assurhospi.prime != null">{{Assurhospi.prime.toLocaleString()}} FCFA</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="wizard-card-footer clearfix mb-5">
                                        <div class="wizard-footer-left">
                                        </div>
                                        <div class="wizard-footer-right">
                                            
                                            <button @click="DevisNextStep()" type="button" class="wizard-btn">
                                                {{ $t('devis.devis_vie.sunuassur.bouton_suivant_label') }}
                                            </button>
                                        </div>
                                        <!---->
                                    </div>
                                    </div>
                                </div>

                                <div class="page" v-show="step === 2">
                                    <div class="wizard-tab-content">
                                            <div role="tabpanel" id="Step8" aria-hidden="true" aria-labelledby="step-Step8" class="wizard-tab-container">
                                                <div v-if="isContractant">
                                                    <div class="loan-group loan-group-0">
                                                        <div class="fields">
                                                            <div class="field-title font-weight-bold">{{ $t('devis.devis_vie.sunuassur.secondStep.title') }}&nbsp;:</div>
                                                            <div class="justify-content-center row">
                                                                <div class="col-sm-5 field-radio field-radio-center">
                                                                    <div class="btn-choice">
                                                                        <input v-model="Assurhospi.Contractant.Genre" value="homme" type="radio" id="monsieur_mobile" name="genre_mobile" class="field-input">
                                                                        <label for="monsieur_mobile" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.monsieur_label') }}</label>
                                                                    </div>
                                                                    <div class="btn-choice">
                                                                        <input v-model="Assurhospi.Contractant.Genre" value="femme" type="radio" id="madame_mobile" name="genre_mobile" class="field-input" >
                                                                        <label for="madame_mobile" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.madame_label') }}</label>
                                                                    </div>
                                                                </div>
                                                                <div class="mt-3 col-sm-5 field-radio field-radio-center">
                                                                    <div class="btn-choice">
                                                                        <input v-model="Assurhospi.Contractant.Genre" value="entreprise" type="radio" id="entreprise_mobile" name="genre_mobile" class="field-input" >
                                                                        <label for="entreprise_mobile" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.entreprise_label') }}</label>
                                                                    </div>
                                                                </div>
                                                                
                                                                <div class="mt-4 col-sm-5 field-radio field-radio-center">
                                                                    <div class="btn-choice">
                                                                        <input v-model="Assurhospi.Contractant.Situation" value="marié" type="radio" id="marie_mobile" name="situation_mobile" class="field-input" >
                                                                        <label for="marie_mobile" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.marie_label') }}</label>
                                                                    </div>
                                                                    <div class="btn-choice">
                                                                        <input v-model="Assurhospi.Contractant.Situation" value="célibataire" type="radio" id="celibat_mobile" name="situation_mobile" class="field-input" >
                                                                        <label for="celibat_mobile" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.celibat_label') }}</label>
                                                                    </div>
                                                                </div>
                                                                <div class="mt-3 col-sm-5 field-radio field-radio-center">
                                                                    <div class="btn-choice">
                                                                        <input v-model="Assurhospi.Contractant.Situation" value="veuf" type="radio" id="veuf_mobile" name="situation_mobile" class="field-input" >
                                                                        <label for="veuf_mobile" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.veuf_label') }}</label>
                                                                    </div>
                                                                    <div class="btn-choice">
                                                                        <input v-model="Assurhospi.Contractant.Situation" value="divorce" type="radio" id="divorce_mobile" name="situation_mobile" class="field-input" >
                                                                        <label for="divorce_mobile" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.divorce_label') }}</label>
                                                                    </div>
                                                                </div>
                                                            
                                                            </div>
                                                        </div>

                                                        <div class="fields">
                                                            <div class="row">
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="nom_contractant_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.nom_label') }}</label>
                                                                        <input v-model="Assurhospi.Contractant.Nom" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.contractant_form.nom_placeholder')" id="nom_contractant_mobile" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="prenom_contractant_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.prenom_label') }}</label>
                                                                        <input v-model="Assurhospi.Contractant.Prenom" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.contractant_form.prenom_placeholder')" id="prenom_contractant_mobile" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="date_naiss_contractant_mobile" class="field-label">
                                                                            {{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.date_naissance_label') }}
                                                                            <!---->
                                                                        </label>
                                                                        <div class="input-group value-loan">
                                                                            <date-picker class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.contractant_form.date_naissance_placeholder')" id="date_naiss_contractant_mobile" @change="yearsDiffContractant()" v-model="Assurhospi.Contractant.dateNaissance" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="lieu_naiss_contractant_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.lieu_naissance_label') }}</label>
                                                                        <input v-model="Assurhospi.Contractant.LieuNaissance" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.contractant_form.lieu_naissance_placeholder')" id="lieu_naiss_contractant_mobile" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="profession_contractant_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.profession_label') }}</label>
                                                                        <input v-model="Assurhospi.Contractant.Profession" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.contractant_form.profession_placeholder')" id="profession_contractant_mobile" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="adresse_contractant_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.adresse_label') }}</label>
                                                                        <input v-model="Assurhospi.Contractant.Adresse" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.contractant_form.adresse_placeholder')" id="adresse_contractant_mobile" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="telephone_contractant_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.telephone_label') }}</label>
                                                                        <input @keypress="onlyNumber" v-model="Assurhospi.Contractant.Telephone" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.contractant_form.telephone_placeholder')" id="telephone_contractant_mobile" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="email_contractant_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.email_label') }}</label>
                                                                        <input v-model="Assurhospi.Contractant.Email" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.contractant_form.email_placeholder')" id="email_contractant_mobile" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="cni_contractant_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.cni_label') }}</label>
                                                                        <input @keypress="onlyNumber" v-model="Assurhospi.Contractant.Cni" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.contractant_form.cni_placeholder')" id="cni_contractant_mobile" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>

                                                    <div class="wizard-card-footer clearfix mb-5">
                                                        <div class="wizard-footer-left">
                                                            <button @click="returToFirstStep()" type="button" class="wizard-btn">
                                                            <span class="fas fa-arrow-left"></span>
                                                            {{$t('devis.devis_vie.sunuassur.bouton_retour_label')}}
                                                            </button>
                                                        </div>
                                                        <div class="wizard-footer-right">
                                                            <button @click="ContractControl()" type="button" class="wizard-btn">
                                                                {{$t('devis.devis_vie.sunuassur.bouton_suivant_label')}}
                                                            </button>
                                                        </div>
                                                        <!---->
                                                    </div>
                                                </div>
                                            </div>
                                    </div>
                                </div>

                                <div class="page" v-show="step === 3">
                                    <div class="wizard-tab-content">
                                            <div role="tabpanel" id="Step8" aria-hidden="true" aria-labelledby="step-Step8" class="wizard-tab-container">
                                                <div v-if="isAssure">
                                                    <div class="loan-group loan-group-0"> 
                                                        <div class="fields">
                                                            <div class="field-title font-weight-bold">{{ $t('devis.devis_vie.sunuassur.secondStep.assure_title') }}&nbsp;:</div>
                                                            <div class="row">
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <div class="field-checkbox">
                                                                        <!-- <div class="field-label">
                                                                            Le contractant est l'assuré ?
                                                                        </div> -->
                                                                        <div class="switch">
                                                                            <label for="assur_question"><span class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.question_assure_title') }}</span>
                                                                            <input style="margin-top:5px" @change="toggleCheckbox()" v-model="checkbox" type="checkbox" id="assur_question" name="Step12">
                                                                            <span style="margin-top: 5px;" class="lever"></span>
                                                                            </label>
                                                                        </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="fields">
                                                            <div class="row">
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="nom_assure_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.assure_form.nom_label') }}</label>
                                                                        <input v-model="Assurhospi.Assure.Nom" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.assure_form.nom_placeholder')" id="nom_assure_mobile" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="prenom_assure_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.assure_form.prenom_label') }}</label>
                                                                        <input v-model="Assurhospi.Assure.Prenom" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.assure_form.prenom_placeholder')" id="prenom_assure_mobile" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="date_naiss_assure_mobile" class="field-label">
                                                                            {{ $t('devis.devis_vie.sunuassur.secondStep.assure_form.date_naissance_label') }}
                                                                            <!---->
                                                                        </label>
                                                                        <div class="input-group value-loan">
                                                                            <date-picker disabled class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.assure_form.date_naissance_placeholder')" id="date_naiss_assure_mobile" @change="yearsDiffAssure()" v-model="Assurhospi.Assure.dateNaissance" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="lieu_naiss_assure_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.assure_form.lieu_naissance_label') }}</label>
                                                                        <input v-model="Assurhospi.Assure.LieuNaissance" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.assure_form.lieu_naissance_placeholder')" id="lieu_naiss_assure_mobile" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="profession_assure_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.assure_form.profession_label') }}</label>
                                                                        <input v-model="Assurhospi.Assure.Profession" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.assure_form.profession_placeholder')" id="profession_assure_mobile" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="adresse_assure_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.assure_form.adresse_label') }}</label>
                                                                        <input v-model="Assurhospi.Assure.Adresse" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.assure_form.adresse_placeholder')" id="adresse_assure_mobile" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="telephone_assure_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.assure_form.telephone_label') }}</label>
                                                                        <input @keypress="onlyNumber" v-model="Assurhospi.Assure.Telephone" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.assure_form.telephone_placeholder')" id="telephone_assure_mobile" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="email_assure_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.assure_form.email_label') }}</label>
                                                                        <input v-model="Assurhospi.Assure.Email" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.assure_form.email_placeholder')" id="email_assure_mobile" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="lieu_exercice_assure_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.assure_form.lieu_exercice_label') }}</label>
                                                                        <input v-model="Assurhospi.Assure.LieuExe" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.assure_form.lieu_exercice_placeholder')" id="lieu_exercice_assure_mobile" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="lieu_exercice_assure_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.assure_form.cni_label') }} *</label>
                                                                        <input @keypress="onlyNumber" v-model="Assurhospi.Assure.Cni" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.assure_form.cni_placeholder')" id="lieu_exercice_assure_mobile" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="wizard-card-footer clearfix mb-5">
                                                        <div class="wizard-footer-left">
                                                            <button @click="returToSecondStep()" type="button" class="wizard-btn">
                                                            <span class="fas fa-arrow-left"></span>
                                                            {{$t('devis.devis_vie.sunuassur.bouton_retour_label')}}
                                                            </button>
                                                        </div>
                                                        <div class="wizard-footer-right">
                                                            <button @click="AssureControl()" type="button" class="wizard-btn">
                                                                {{$t('devis.devis_vie.sunuassur.bouton_suivant_label')}}
                                                            </button>
                                                        </div>
                                                        <!---->
                                                    </div>
                                                </div>
                                            </div>
                                    </div>
                                </div>

                                <div class="page" v-show="step === 4">
                                    <div class="wizard-tab-content">
                                            <div role="tabpanel" id="Step8" aria-hidden="true" aria-labelledby="step-Step8" class="wizard-tab-container">
                                                <div v-if="isBenef">
                                                    <div class="loan-group loan-group-0"> 
                                                        <div class="fields">
                                                            <div class="field-title font-weight-bold">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_title') }}&nbsp;:</div>
                                                            <div class="row">
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="nom_benef_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.nom_label') }}</label>
                                                                        <input v-model="Assurhospi.Beneficiaire.Nom" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.benef_form.nom_placeholder')" id="nom_benef_mobile" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="prenom_benef_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.prenom_label') }}</label>
                                                                        <input v-model="Assurhospi.Beneficiaire.Prenom" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.benef_form.prenom_placeholder')" id="prenom_benef_mobile" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="date_naiss_benef_mobile" class="field-label">
                                                                            {{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.date_naissance_label') }}
                                                                            <!---->
                                                                        </label>
                                                                        <div class="input-group value-loan">
                                                                            <date-picker disabled class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.benef_form.date_naissance_placeholder')" id="date_naiss_benef_mobile" @change="yearsDiffBenef()" v-model="Assurhospi.Beneficiaire.dateNaissance" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="lieu_naiss_benef_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.lieu_naissance_label') }}</label>
                                                                        <input v-model="Assurhospi.Beneficiaire.LieuNaissance" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.benef_form.lieu_naissance_placeholder')" id="lieu_naiss_benef_mobile" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="cni_benef_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.cni_label') }} *</label>
                                                                        <input @keypress="onlyNumber" v-model="Assurhospi.Beneficiaire.Cni" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.benef_form.cni_placeholder')" id="cni_benef_mobile" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="filiation_benef_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.filiation_label') }}</label>
                                                                        <select v-model="Assurhospi.Beneficiaire.Filiation" id="filiation_benef_mobile" name="Step8" class="field-select">
                                                                            <option></option>
                                                                            <option value="pere_mere">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.filiation_hospi_select.pere_mere') }}</option>
                                                                            <option value="fils_fille">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.filiation_hospi_select.fils_fille') }}</option>
                                                                            <option value="frere_soeur">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.filiation_hospi_select.frere_soeur') }}</option>
                                                                            <option value="epoux_epouse">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.filiation_hospi_select.epoux_epouse') }}</option>
                                                                            <option value="autres">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.filiation_hospi_select.autre_label') }}</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="wizard-card-footer clearfix mb-5">
                                                        <div class="wizard-footer-left">
                                                            <button @click="returToThirstStep()" type="button" class="wizard-btn">
                                                            <span class="fas fa-arrow-left"></span>
                                                            {{$t('devis.devis_vie.sunuassur.bouton_retour_label')}}
                                                            </button>
                                                        </div>
                                                        <div class="wizard-footer-right">
                                                            <button @click="BenefControl()" type="button" class="wizard-btn">
                                                                {{$t('devis.devis_vie.sunuassur.bouton_suivant_label')}}
                                                            </button>
                                                        </div>
                                                        <!---->
                                                    </div>
                                                </div>
                                            </div>
                                    </div>
                                </div>

                                <div class="page review_page" v-show="step === 5">
                                    <div data-v-221edead="" class="w-100 Results" pricing="true" style="--custom-color-primary:#35CE7E; --custom-color-primary-light:#5CC7000d;">
                                    <div role="tabpanel" id="devis_iAc" aria-labelledby="step-devis_iAc" class="wizard-tab-container">
                                        <div data-v-0d43d413="">
                                        <div data-v-0d43d413="" class="fields">
                                            <div data-v-0d43d413="" class="font-weight-bold field-title mb-0 row justify-content-center">
                                                {{ $t('devis.devis_vie.sunuassur.validationStep.title') }}
                                            </div>
                                        </div>
                                        </div>
                                    </div>

                                    <div data-v-221edead="">
                                        <div data-v-221edead="" class="results-deals">
                                        <div data-v-221edead="" id="results-table">
                                            <div data-v-221edead="" style="top: 0px; width: 100%;">
                                            <div data-v-221edead="" class="card-default result text-center naoassur elevation-10">
                                                <div data-v-221edead="" class="card-default-body">
                                                <h1 class="field-title row justify-content-center">{{ $t('devis.devis_vie.sunuassur.validationStep.contractant.title') }}</h1>
                                                <div data-v-221edead="" class="logo-company logo-company-economy">
                                                    <ul class="to-left mb-3 mr-3 policeLato">
                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.contractant.genre_label') }} :
                                                            <span v-if="Assurhospi.Contractant.Genre == 'homme'" class="font-weight-bold to-right">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.monsieur_label') }}</span>
                                                            <span v-if="Assurhospi.Contractant.Genre == 'femme'" class="font-weight-bold to-right">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.madame_label') }}</span>
                                                        </li>

                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.contractant.situation_label') }} :
                                                            <span v-if="Assurhospi.Contractant.Situation == 'marié'" class="font-weight-bold to-right">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.marie_label') }}</span>
                                                            <span v-if="Assurhospi.Contractant.Situation == 'célibataire'" class="font-weight-bold to-right">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.celibat_label') }}</span>
                                                            <span v-if="Assurhospi.Contractant.Situation == 'veuf'" class="font-weight-bold to-right">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.veuf_label') }}</span>
                                                            <span v-if="Assurhospi.Contractant.Situation == 'divorce'" class="font-weight-bold to-right">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.divorce_label') }}</span>
                                                        </li>

                                                        <li  class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.contractant.nom_label') }} :
                                                        <span class="font-weight-bold to-right">{{Assurhospi.Contractant.Nom}}</span>
                                                        </li>

                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.contractant.prenom_label') }} :
                                                        <span class="font-weight-bold to-right">{{Assurhospi.Contractant.Prenom}}</span>
                                                        </li>

                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.contractant.date_naissance_label') }} :
                                                        <span class="font-weight-bold to-right">{{DateFormater(Assurhospi.Contractant.dateNaissance)}}</span>
                                                        </li>

                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.contractant.lieu_naissance_label') }} :
                                                        <span class="font-weight-bold to-right">{{Assurhospi.Contractant.LieuNaissance}}</span>
                                                        </li>

                                                        <li  class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.contractant.profession_label') }} :
                                                        <span class="font-weight-bold to-right">{{Assurhospi.Contractant.Profession}}</span>
                                                        </li>

                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.contractant.adresse_label') }} :
                                                        <span class="font-weight-bold to-right">{{Assurhospi.Contractant.Adresse}}</span>
                                                        </li>

                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.contractant.telephone_label') }} :
                                                        <span class="font-weight-bold to-right">{{Assurhospi.Contractant.Telephone}}</span>
                                                        </li>

                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.contractant.email_label') }} :
                                                        <span class="font-weight-bold to-right">{{Assurhospi.Contractant.Email}}</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                        </div>
                                    </div>

                                    <div data-v-221edead="">
                                        <div data-v-221edead="" class="results-deals">
                                        <div data-v-221edead="" id="results-table">
                                            <div data-v-221edead="" style="top: 0px; width: 100%;">
                                            <div data-v-221edead="" class="card-default result text-center naoassur elevation-10">
                                                <div data-v-221edead="" class="card-default-body">
                                                <h1 class="field-title row justify-content-center">{{ $t('devis.devis_vie.sunuassur.validationStep.assure.title') }}</h1>
                                                <div data-v-221edead="" class="logo-company logo-company-economy">
                                                    <ul class="to-left mb-3 mr-3 policeLato">
                                                        <li  class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.assure.nom_label') }} :
                                                        <span class="font-weight-bold to-right">{{Assurhospi.Assure.Nom}}</span>
                                                        </li>

                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.assure.prenom_label') }} :
                                                        <span class="font-weight-bold to-right">{{Assurhospi.Assure.Prenom}}</span>
                                                        </li>

                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.assure.date_naissance_label') }} :
                                                        <span class="font-weight-bold to-right">{{DateFormater(Assurhospi.Assure.dateNaissance)}}</span>
                                                        </li>

                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.assure.lieu_naissance_label') }} :
                                                        <span class="font-weight-bold to-right">{{Assurhospi.Assure.LieuNaissance}}</span>
                                                        </li>

                                                        <li  class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.assure.profession_label') }} :
                                                        <span class="font-weight-bold to-right">{{Assurhospi.Assure.Profession}}</span>
                                                        </li>

                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.assure.adresse_label') }} :
                                                        <span class="font-weight-bold to-right">{{Assurhospi.Assure.Adresse}}</span>
                                                        </li>

                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.assure.telephone_label') }} :
                                                        <span class="font-weight-bold to-right">{{Assurhospi.Assure.Telephone}}</span>
                                                        </li>

                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.assure.email_label') }} :
                                                        <span class="font-weight-bold to-right">{{Assurhospi.Assure.Email}}</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                        </div>
                                    </div>

                                    <div data-v-221edead="">
                                        <div data-v-221edead="" class="results-deals">
                                        <div data-v-221edead="" id="results-table">
                                            <div data-v-221edead="" style="top: 0px; width: 100%;">
                                            <div data-v-221edead="" class="card-default result text-center naoassur elevation-10">
                                                <div data-v-221edead="" class="card-default-body">
                                                <h1 class="field-title row justify-content-center">{{ $t('devis.devis_vie.sunuassur.validationStep.beneficiaire.title') }}</h1>
                                                <div data-v-221edead="" class="logo-company logo-company-economy">
                                                    <ul class="to-left mb-3 mr-3 policeLato">
                                                        <li  class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.beneficiaire.nom_label') }} :
                                                        <span class="font-weight-bold to-right">{{Assurhospi.Beneficiaire.Nom}}</span>
                                                        </li>

                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.beneficiaire.prenom_label') }} :
                                                        <span class="font-weight-bold to-right">{{Assurhospi.Beneficiaire.Prenom}}</span>
                                                        </li>

                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.beneficiaire.date_naissance_label') }} :
                                                        <span class="font-weight-bold to-right">{{DateFormater(Assurhospi.Beneficiaire.dateNaissance)}}</span>
                                                        </li>

                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.beneficiaire.lieu_naissance_label') }} :
                                                        <span class="font-weight-bold to-right">{{Assurhospi.Beneficiaire.LieuNaissance}}</span>
                                                        </li>

                                                        <li  class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.beneficiaire.filiation_label') }} :
                                                            <span v-if="Assurhospi.Beneficiaire.Filiation == 'pere_mere'" class="font-weight-bold to-right">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.filiation_hospi_select.pere_mere') }}</span>
                                                            <span v-if="Assurhospi.Beneficiaire.Filiation == 'fils_fille'" class="font-weight-bold to-right">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.filiation_hospi_select.fils_fille') }}</span>
                                                            <span v-if="Assurhospi.Beneficiaire.Filiation == 'frere_soeur'" class="font-weight-bold to-right">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.filiation_hospi_select.frere_soeur') }}</span>
                                                            <span v-if="Assurhospi.Beneficiaire.Filiation == 'epoux_epouse'" class="font-weight-bold to-right">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.filiation_hospi_select.epoux_epouse') }}</span>
                                                            <span v-if="Assurhospi.Beneficiaire.Filiation == 'autres'" class="font-weight-bold to-right">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.filiation_hospi_select.autre_label') }}</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                        </div>
                                    </div>

                                    <div role="tabpanel" id="devis_auto" aria-labelledby="step-devis_auto" class="mt-3 wizard-tab-container">
                                    <div data-v-0d43d413="">
                                    <div data-v-0d43d413="" class="fields">
                                        <div data-v-0d43d413="" class="font-weight-bold field-title mb-0 row justify-content-center">
                                            {{ $t('devis.devis_vie.sunuassur.validationStep.periode.title') }}
                                        </div>

                                        <div class="row">
                                        <div class="col-sm-6">
                                            <div class="field-group field-default mb-4 mb-sm-0">
                                            <label for="Stepper39_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.validationStep.periode.date_effet') }}
                                                <button type="button" tabindex="-1" title="" class="field-help" data-original-title="Taux d'intérêt"></button></label>
                                            <div class="input-group rate-loan">
                                                <date-picker id="Stepper39_mobile" :disabled-date="disabledAfterToday"  class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_vie.sunuassur.validationStep.periode.date_effet_placeholder')" @change="dateDiff()" :min="new Date().toISOString().substr(0, 10)" v-model="Assurhospi.dateEffet" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                            </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <div class="field-group field-default mb-4 mb-sm-0">
                                            <label for="Stepper40_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.validationStep.periode.date_echeance') }}
                                                <button type="button" tabindex="-1" title="" class="field-help" data-original-title="Taux d'intérêt"></button></label>
                                            <div class="input-group rate-loan">
                                                <input disabled :placeholder="$t('devis.devis_vie.sunuassur.validationStep.periode.date_echeance_placeholder')" v-model="Assurhospi.dateEcheance" id="Stepper40_mobile" name="Step11" class="field-input">
                                            </div>
                                            </div>
                                        </div>
                                        </div>

                                        <div class="fields">
                                            <div class="field-group row flex-column flex-sm-row">
                                                <div class="justify-content-center row ml-3 mr-3">
                                                    <ul class="to-left mb-3 mr-3 policeLato">
                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.garantie.duree_label') }} :
                                                        <span style="color:#ffa409" class="font-weight-bold to-right">{{Assurhospi.duree}} {{ $t('devis.devis_vie.sunuassur.validationStep.garantie.mois_label') }}</span>
                                                        </li>

                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.garantie.capital_hospi_label') }} :
                                                        <span style="color:#ffa409" class="font-weight-bold to-right" v-if="Assurhospi.capital != null">{{Assurhospi.capital.toLocaleString()}} FCFA</span>
                                                        </li>
                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.garantie.prime_mensuel_label') }} :
                                                        <span style="color:#ffa409" class="font-weight-bold to-right" v-if="this.Assurhospi.prime != null">{{Assurhospi.prime.toLocaleString()}} FCFA</span>
                                                        </li>
                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.garantie.branche_label') }} :
                                                        <span style="color:#ffa409" class="font-weight-bold to-right">{{Assurhospi.branche}}</span>
                                                        </li>
                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.garantie.assureur_label') }} :
                                                        <span style="color:#ffa409" class="font-weight-bold to-right">{{Assurhospi.assureur}}</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    </div>
                                </div>

                                  </div>

                                  <div class="wizard-card-footer clearfix">
                                    <div class="wizard-footer-left">
                                        
                                    </div>
                                    <div class="wizard-footer-right">
                                        <button :disabled="disabledButtonValidate" @click="CreateDevis()" type="button" class="wizard-btn">
                                            {{ $t('devis.devis_vie.sunuassur.bouton_valider_label') }}
                                        </button>
                                    </div>
                                    <!---->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
               
            </div>
        </div>
        

        <!-- <v-dialog v-model="dialogLoading" persistent width="700" v-if="isDesktop()">
            <v-card elevation="24" class="border-radius">
                <v-card-text style="background:#FFA409">
                <div class="wizard-tab-content" style="background:#FFA409">
                    <div role="tabpanel" id="infosPerso" aria-hidden="true" aria-labelledby="step-infosPerso" class="wizard-tab-container">
                    <div>
                        <div class="loan-group loan-group-0" style="background:#FFA409">
                        <div class="fields text-center" style="background:#FFA409">
                            <v-progress-circular size="50" color="white" class="mr-2" indeterminate></v-progress-circular> 
                            <span class="field-title font-weight-bold" style="color:#fff">{{$t('devis.devis_voyage.devis_encours')}}</span>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                </v-card-text>
            </v-card>
        </v-dialog> -->

        <div v-if="dialogLoading" class="loading-state">
        <div class="loading"></div>
        <span class="ml-3 loading-text">{{$t('devis.devis_voyage.devis_encours')}}</span>
    </div>


        <!-- <v-dialog v-model="dialogLoading" persistent width="700" v-if="isMobile()">
            <v-card elevation="24" class="border-radius">
            <v-card-text style="background:#FFA409">
                <div class="wizard-tab-content" style="background:#FFA409">
                <div role="tabpanel" id="infosPerso" aria-hidden="true" aria-labelledby="step-infosPerso" class="wizard-tab-container">
                    <div>
                    <div class="loan-group loan-group-0" style="background:#FFA409">
                        <div class="fields text-center" style="background:#FFA409">
                            <span class="field-title font-weight-bold" style="color:#fff">{{$t('devis.devis_voyage.devis_encours')}}</span>
                        </div>
                        <div class="fields text-center" style="background:#FFA409">
                            <v-progress-circular size="50" color="white" class="mr-2" indeterminate></v-progress-circular>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </v-card-text>
            </v-card>
        </v-dialog> -->

        <!-- INCLUSION DU POPUP DE LOGIN AU CAS OU LE USER VOULANT FAIRE UNE VALIDATION N'EST PAS CONNECTE -->
        <login-form :visible="showLoginForm" @close="showLoginForm=false"></login-form>
    </div>
</template>

<script>
    import dayjs from 'dayjs'
    import Api from '../../services/Api'
    import store from '../../store/store'
    import LoginForm from '../auth/Login'
    import AssurHospi from "./../../models/micro/Assurhospi"


    const validateEmail = email => {
        if (!email.length) {
            return {valide: false, error: "L'adresse mail est obligatoire!"};
        } else if (!email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) {
            return { valide: false, error: "Veuillez entrer un email valide!" };
        } else {
            return { valide: true, error: null };
        }
    };

    const validatePhone = phone => {

        if(!phone.length){
            return { valide: false, error: 'Le numéro de téléphone est obligatoire.' };
        }else if (phone.length < 9) {
            return { valide: false, error: 'Le numéro de téléphone doit contenir 9 chiffres au minimum.' };
        }else{
            return { valide: true, error: null };
        }

    };

    export default {
        name: 'Devis_sunuAssur',
        components: {
            LoginForm
        },
        data() {
            return {
                formule: null,
                nbmois: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
                listecapitaux: [
                    {
                        capital: 100000,
                        hospitalisation: 150000,
                        prime: 340,
                    },
                    {
                        capital: 500000,
                        hospitalisation: 750000,
                        prime: 1700,
                    },
                    {
                        capital: 1000000,
                        hospitalisation: 1500000,
                        prime: 3400,
                    }

                ],
                Assurhospi: new AssurHospi(),

                choix : 'capital',
                dialogLoading : false,
                disabledButtonValidate : false,
                step: 1,
                dateSouscription: new Date().toISOString().substr(0, 10),
                neant: 'N.A',
                date: new Date().toISOString().substr(0, 10),
                first_questionnaire : true,
                isCapital : true,
                isRente : false,
                choixRente : null,
                oldDate : null,
                bottomPushNotif : false,
                disableDateAssure: true,
                Modalite : null,
                Assureur :'',
                money:{
                    thousands: ' ',
                    precision: false,
                    masked: false,
                },
                dateNaiss : null,
                duree : null,
                Capital:true,
                dateEffet: null,
                dateEcheance: null,
                e1: 1,
                elevation: 2,
                activeStep: 0,
                checkbox: false,
                errors: {},
                disable: false,
                valide: null,
                age: null,
                genre: null,
                branche: null,
                dialog: false,
                IsPaid: false,
                adresse: false,
                checked : false,
                showLoginForm: false,
                animation: 'animate-in',
                NomAssure: null,
                isContractant: true,
                isAssure: false,
                isBenef: false,
              
                isPayment : false,
              
                ToastTabSucess: {
                    theme: 'toasted-primary',
                    position: 'top-center',
                    duration: 4000,
                    fitToScreen: true,
                    type: 'success',
                    className: 'custom-success-class'
                }, // Customized options for success toast
                ToastTabError: {
                    theme: 'toasted-primary',
                    position: 'top-center',
                    duration: 4000,
                    fitToScreen: true,
                    type: 'error'
                }, // Customized options for error toast

                formSteps: [
                    {
                        title: "CONTRACTANT",
                        fields: [
                                    { valid: true },
                                ]
                    },
                    {
                        title: "ASSURE",
                        fields: [
                            { valid: true },
                               ]
                    },
                    {
                        title: "BENEFICIAIRE",
                        fields: [
                            { valid: true },
                                ]
                    },
                ],
            }
        },
        methods: {
            setFormuleDureeCapitaux() {
            this.Assurhospi.prime = this.formule.prime * this.Assurhospi.duree

            },
            setFormuleCapitaux() {
                this.formule = this.listecapitaux.find(cap => cap.capital == this.Assurhospi.capital)
                this.Assurhospi.hospitalisation = this.formule.hospitalisation
                this.Assurhospi.prime = this.formule.prime
                this.Assurhospi.duree = 1
            },
            

            /*=============Filtre sans le + ni lettre sur les champs de type number ===========*/
            onlyNumber($event) {
            let NumOnly = ($event.NumOnly ? $event.NumOnly : $event.which);
            if ((NumOnly < 48 || NumOnly > 57) && NumOnly !== 46) {
                $event.preventDefault();
            }
            },
            /*================= retour à la premiere étape ==============*/
            returToFirstStep(){
                document.getElementById("firstStep").classList.remove('checked');
                document.getElementById("testup").classList.remove('widthFirst');
                this.step = 1
            },
            returToSecondStep(){
                this.activeStep -= 1;
                this.isContractant = true,
                this.isAssure = false
                this.step = 2
                document.getElementById("secondStep").classList.remove('checked');
                document.getElementById("testup").classList.remove('widthSecond');
            },
             /*================= retour à la troisieme étape ==============*/
            returToThirstStep(){
                this.activeStep -= 1;
                this.isContractant = false,
                this.isAssure = true
                this.isBenef = false
                this.step = 3
                document.getElementById("testup").classList.remove('widthThirt');
            },
             /*================= retour à la quatrieme étape ==============*/
             returToFourStep(){
                this.activeStep -= 1;
                this.isContractant = false,
                this.isAssure = false
                this.isBenef = true
                this.Questionnaire = false
                this.step = 4
                document.getElementById("secondStep").classList.remove('checked');
                document.getElementById("testup").classList.remove('widthFour');
            },
              //Date object formater to String
            DateFormater: function (TheDate) {
            if (TheDate) {
                return dayjs(TheDate).format('DD-MM-YYYY')
            }
            },
            disabledBeforeToday(date) {
              const today = dayjs(this.dateDepart).add(+1, 'day')
              return date < today;
            },
            disabledAfterToday(date) {
              const today = dayjs(new Date()).add(-1, 'day')
              return date < today;
            },
            disabledAfterTodayBirth(date) {
              const today = dayjs(new Date()).add(-1, 'day')
              return date > today;
            },
         
            prev() {
                this.step--;
            },
            next() {
                this.step++;
            },

            /*===Send of data to API allowing create proposition for the customer===*/
            CreateDevis: function(){
                if (!store.state.isUserLoggedIn) {
                   this.showLoginForm = true
               } else {
                    if(this.Assurhospi.dateEffet){
                        const ASSURHOSPI = {
                            Contractant: this.Assurhospi.Contractant,
                            Assure: this.Assurhospi.Assure,
                            Beneficiaire : this.Assurhospi.Beneficiaire,
                            duree : this.Assurhospi.duree,
                            branche: this.Assurhospi.branche,
                            assureurs:this.Assurhospi.assureur,
                            userid: store.state.user._id,
                            clientid: store.state.user._id,
                            createur: store.state.user._id,
                            //dateEffet: this.Assurhospi.dateEffet,
                            dateEffet : dayjs(this.Assurhospi.dateEffet).format("YYYY-MM-DD"),
                            dateEcheance: this.Assurhospi.dateEcheance,
                            garanties: this.Assurhospi.garanties,
                            dateSouscription: dayjs(new Date()).format('YYYY-MM-DD'),
                            prime_mensuelle : this.Assurhospi.prime,
                            //capital : Number(this.Assurhospi.capital.replace(/[^0-9.-]+/g, "")),
                            capital : this.Assurhospi.capital,
                            hospitalisation : Number(this.Assurhospi.hospitalisation),
                            plateforme:"Front",
                            FuturPaiement : null,
                        };
                        
                        this.disabledButtonValidate = true
                        this.dialogLoading = true;

                        Api().post('micro/devis/sunuvie', ASSURHOSPI)
                            .then((result) => {
                                Api().get('devis/' + result.data.devis._id)
                                    .then(response => {
                                        document.getElementById("testup").classList.add('widthSix');
                                        //document.getElementById("fourStep").classList.add('checked');
                                        this.$store.dispatch('setDevisPayement', response.data);
                                            this.dialogLoading = false, 
                                            this.disabledButtonValidate = false, 
                                            this.$router.push('/payement') 
                                    })
                            }).catch((err) => {
                            console.log('error')
                        });
                        
                    }else {
                        this.$toasted.show( "Date d'effet obligatoire!", this.ToastTabError)
                    }

                  
               }
           },


            DevisNextStep(){
                const date1 = dayjs(this.Assurhospi.Beneficiaire.dateNaissance);

                const date2 = dayjs(new Date().toISOString().substr(0, 10));
                let daydiff = date2.diff(date1, 'days');

                this.oldDate = dayjs(this.dateNaiss)
                daydiff = date2.diff(this.oldDate, "days");

                let yearAss = Math.floor(daydiff/360)
                if (this.Assurhospi.Beneficiaire.dateNaissance == null || this.dateNaiss == null || this.Assurhospi.capital == null) {
                this.$toasted.show('Tous les champs sont obligatoires ! ', this.ToastTabError)
                return;
            }
            if (yearAss < 18 || yearAss > 60) {
                this.$toasted.show("Date assuré doit etre dans l'interval 18 a 60ans ! ", this.ToastTabError)
                return;
            }
                if(store.state.isUserLoggedIn){
                    this.Assurhospi.Contractant.Nom = this.$store.state.user.nom
                    this.Assurhospi.Contractant.Prenom = this.$store.state.user.prenom
                    this.Assurhospi.Contractant.Telephone = this.$store.state.user.telephone_port
                    this.Assurhospi.Contractant.Email = this.$store.state.user.email
                    this.Assurhospi.Contractant.dateNaissance = this.$store.state.user.datenaissance
                    this.Assurhospi.Contractant.Genre = this.$store.state.user.sexe
                    this.Assurhospi.Contractant.Situation = this.$store.state.user.statut_marital
                    this.Assurhospi.Contractant.Profession = this.$store.state.user.profession
                    this.Assurhospi.Contractant.Adresse = this.$store.state.user.adresse
                    this.Assurhospi.Contractant.Cni = this.$store.state.user.numero_piece
                    this.step = 2
                    this.Assurhospi.Assure.dateNaissance = this.dateNaiss
                    document.getElementById("testup").classList.add('widthFirst');
                    document.getElementById("firstStep").classList.add('checked');
                }else {
                    this.showLoginForm = true
                }
            },

            
            toggleCheckbox() {
                if(this.checkbox == true){
                    this.Assurhospi.Assure.Nom = this.Assurhospi.Contractant.Nom
                    this.Assurhospi.Assure.Prenom = this.Assurhospi.Contractant.Prenom
                    this.Assurhospi.Assure.LieuNaissance = this.Assurhospi.Contractant.LieuNaissance
                    this.Assurhospi.Assure.Profession = this.Assurhospi.Contractant.Profession
                    this.Assurhospi.Assure.Adresse = this.Assurhospi.Contractant.Adresse
                    this.Assurhospi.Assure.Telephone = this.Assurhospi.Contractant.Telephone
                    this.Assurhospi.Assure.Email = this.Assurhospi.Contractant.Email
                    this.disableDateAssure = true
                    this.AssureControl()
                }else if(this.checkbox == false){
                    this.Assurhospi.Assure.dateNaissance = this.oldDate
                    this.dateNaiss = this.oldDate
                    this.ClearForm()
                }
            },
            ClearForm: function () {
                this.Assurhospi.Assure.Nom = null
                this.Assurhospi.Assure.Prenom = null
                //this.Assurhospi.Assure.dateNaissance = null
                this.Assurhospi.Assure.LieuNaissance = null
                this.Assurhospi.Assure.Profession = null
                this.Assurhospi.Assure.Adresse = null
                this.Assurhospi.Assure.Telephone = null
                this.Assurhospi.Assure.Email = null
                this.Assurhospi.Assure.LieuExe = null
            },
            yearsDiff(){
                const date1 = dayjs(this.dateNaiss).year();
                const date2 = new Date().getFullYear();
                let daydiff = date2 - date1
                this.age = daydiff;

                if (this.age <0) {
                    this.age = null;
                    this.$toasted.show('Erreur, date antérieure à la date actuelle! ', this.ToastTabError)
                    this.dateNaiss = null
                } else if (this.age) {
                    if(this.age < 18 || this.age <= 0){
                        this.$toasted.show("Erreur, l'age doit pas être Supérieur à 18 ans! ", this.ToastTabError)
                        this.dateNaiss = null
                    }else if(this.age > 59){
                        this.$toasted.show( "L'année de naissance doit être inferieur à 60 ans!", this.ToastTabError)
                        this.dateNaiss = null
                    }
                }
                else if (this.age<=0) {
                    if(this.age < 18 || this.age <= 0){
                        this.$toasted.show("Erreur, l'age doit pas etre Supérieur à 18 ans! ", this.ToastTabError)
                        this.dateNaiss = null
                    }
                }
              
            },

            yearsDiffContractant() {
                const date1 = dayjs(this.Assurhospi.Contractant.dateNaissance);
                const date2 = dayjs(new Date().toISOString().substr(0, 10));
                let daydiff = date2.diff(date1, 'days');
                this.age = daydiff;

                if (this.age <0) {
                    this.age = null;
                    this.$toasted.show('Erreur, date antérieure à la date actuelle! ', this.ToastTabError)
                    this.Assurhospi.Contractant.dateNaissance = null

                } else if (this.age) {
                    let year = Math.floor(this.age / 360);
                    this.age = year;
                    if(this.age < 18 || this.age <= 0){
                        this.$toasted.show("Erreur, l'age doit pas etre supperieur à 18 ans! ", this.ToastTabError)
                        this.Assurhospi.Contractant.dateNaissance = null
                    }
                }
                else if (this.age<=0) {
                    let year = Math.floor(this.age / 360);
                    this.age = year;
                    if(this.age < 18 || this.age <= 0){
                        this.$toasted.show("Erreur, l'age doit pas etre supperieur à 18 ans! ", this.ToastTabError)
                        this.Assurhospi.Contractant.dateNaissance = null
                    }
                }
            },

            yearsDiffAssure() {
                const date1 = dayjs(this.Assurhospi.Assure.dateNaissance);
                const date2 = dayjs(new Date().toISOString().substr(0, 10));
                let daydiff = date2.diff(date1, 'days');
                this.age = daydiff;

                if (this.age < 0) {
                    this.age = null;
                    this.$toasted.show('Erreur, date antérieure à la date actuelle! ', this.ToastTabError)
                    this.Assurhospi.Assure.dateNaissance = null


                } else if (this.age) {
                    let year = Math.floor(this.age / 360);
                    this.age = year;
                    if(this.age < 18){
                        this.$toasted.show("Erreur, l'age doit pas etre Supérieur à 18 ans! ", this.ToastTabError)
                        this.Assurhospi.Assure.dateNaissance = null
                    }
                }  else if (this.age<=0) {
                    let year = Math.floor(this.age / 360);
                    this.age = year;
                    if(this.age < 18){
                        this.$toasted.show("Erreur, l'age doit pas etre Supérieur à 18 ans! ", this.ToastTabError)
                        this.Assurhospi.Assure.dateNaissance = null
                    }
                }

            },

            yearsDiffBenef() {
                const date1 = dayjs(this.Assurhospi.Beneficiaire.dateNaissance);
                const date2 = dayjs(new Date().toISOString().substr(0, 10));
                let daydiff = date2.diff(date1, 'days');
                this.age = daydiff;

                if (this.age < 0) {
                    this.age = null;
                    this.$toasted.show('Erreur, date antérieure à la date actuelle! ', this.ToastTabError)
                    this.Assurhospi.Beneficiaire.dateNaissance = ""

                }
            },


            BackToStep1(){
                this.animation = 'animate-out-back';
                setTimeout(() => {
                    this.animation = 'animate-in-back';
                    this.step = 2;
                    this.activeStep -= 1;
                    this.isContractant = true,
                    this.isAssure = false
                }, 500);
            },

            BackToStep2(){
                this.animation = 'animate-out-back';
                setTimeout(() => {
                    this.animation = 'animate-in-back';
                    this.activeStep -= 1;
                    this.step = 3;
                    this.isContractant = false,
                        this.isAssure = true
                        this.isBenef = false
                }, 500);
            },

            BackToStep3(){
                this.animation = 'animate-out-back';
                setTimeout(() => {
                    this.animation = 'animate-in-back';
                    this.activeStep -= 1;
                    this.e1 = 4;
                    this.isContractant = false,
                        this.isAssure = false
                    this.isBenef = true
                    this.Questionnaire = false
                }, 600);
            },
            BackToStep4(){
                this.animation = 'animate-out-back';
                setTimeout(() => {
                    this.animation = 'animate-in-back';
                    this.activeStep -= 1;
                    this.e1 = 5;
                    this.isContractant = false,
                    this.isAssure = false
                    this.isBenef = false
                }, 600);
            },

            /*=============Filtre sans le + ni lettre sur les champs de type number ===========*/
            onlyNumber($event) {
                let NumOnly = ($event.NumOnly ? $event.NumOnly : $event.which);
                if ((NumOnly < 48 || NumOnly > 57) && NumOnly !== 46) {
                    $event.preventDefault();
                }
            },

            dateDiff: function () {
                if (this.Assurhospi.dateEffet) {
                let inter = dayjs(this.Assurhospi.dateEffet).add(this.Assurhospi.duree, "month").format("YYYY-MM-DD");
                this.Assurhospi.dateEcheance = dayjs(inter).add(-1, "day").format("YYYY-MM-DD");
            }
            },

            isMobile: function () {
                if (screen.width <= 760) {
                    return true;
                } else {
                    return false;
                }
            },

            isDesktop: function () {
                if (screen.width > 768) {
                    return true;
                } else {
                    return false;
                }
            },

            nextStep() {
                this.animation = 'animate-out';
                setTimeout(() => {
                    this.animation = 'animate-in';
                    this.activeStep += 1;
                    this.isContractant = false,
                    this.isAssure = true
                }, 600);
            },

            nextStep2() {
                this.animation = 'animate-out';
                setTimeout(() => {
                    this.animation = 'animate-in';
                    this.activeStep += 1;
                    this.isContractant = false,
                        this.isAssure = false,
                        this.isBenef =true
                }, 600);
            },

            nextStep3() {
                this.animation = 'animate-out';
                setTimeout(() => {
                    this.animation = 'animate-in';
                    this.activeStep += 1;
                    this.isContractant = false,
                    this.isAssure = false,
                    this.isBenef =false
                }, 600);
            },

            nextStep4() {
                this.animation = 'animate-out';
                setTimeout(() => {
                    this.animation = 'animate-in';
                    this.activeStep += 1;
                    this.isContractant = false,
                        this.isAssure = false,
                        this.isBenef =false,
                        this.isPayment = true
                }, 600);
            },


            ContractControl() {
                this.errors = {}
                if(this.Assurhospi.Contractant.Genre && this.Assurhospi.Contractant.Situation){
                    if (this.Assurhospi.Contractant.Nom && this.Assurhospi.Contractant.Prenom) {
                        if(this.Assurhospi.Contractant.dateNaissance && this.Assurhospi.Contractant.LieuNaissance){
                            if(this.Assurhospi.Contractant.Profession && this.Assurhospi.Contractant.Adresse){
                                if(this.Assurhospi.Contractant.Telephone && this.Assurhospi.Contractant.Email){
                                    const validPhone = validatePhone(this.Assurhospi.Contractant.Telephone);
                                    this.errors.phone = validPhone.error;

                                    const validEmail = validateEmail(this.Assurhospi.Contractant.Email);
                                    this.errors.email = validEmail.error;
                                    if(validEmail.valide == true && validPhone.valide == true){
                                        if(this.Assurhospi.Contractant.Cni){
                                            this.step = 3
                                            document.getElementById("testup").classList.add('widthSecond');
                                            document.getElementById("firstStep").classList.add('checked');
                                            this.nextStep();
                                        }else {
                                            this.$toasted.show('CNI obligatoire! ', this.ToastTabError)
                                            this.animation = 'animate-wrong';
                                            setTimeout(() => {
                                                this.animation = '';
                                            }, 400);
                                        }

                                    }
                                }else {
                                    this.$toasted.show('Téléphone et Email obligatoires! ', this.ToastTabError)
                                }
                            }else {
                                this.$toasted.show('Profession et Adresse obligatoires! ', this.ToastTabError)
                            }
                        }else {
                            this.$toasted.show('Date et Lieu de naissance obligatoires! ', this.ToastTabError)
                        }
                    } else {
                        this.$toasted.show('Nom et Prénom obligatoires! ', this.ToastTabError)
                    }
                }else {
                    this.$toasted.show('Genre et Situation obligatoires! ', this.ToastTabError)
                }

            },

            AssureControl() {
                const date2 = dayjs(new Date().toISOString().substr(0, 10));
                const date1 = dayjs(this.Assurhospi.Assure.dateNaissance);
                let daydiff = date2.diff(date1, "days");
                let yearAss = Math.floor(daydiff / 360);
                if (yearAss < 18 || yearAss > 59) {
                    this.$toasted.show("Date assuré doit etre dans l'interval 18 a 59 ans ! ", this.ToastTabError)
                    return;
                }
                
                this.errors = {}
                if (this.Assurhospi.Assure.Nom && this.Assurhospi.Assure.Prenom) {
                    if(this.Assurhospi.Assure.dateNaissance && this.Assurhospi.Assure.LieuNaissance){
                            if(this.Assurhospi.Assure.Telephone && this.Assurhospi.Assure.Email){
                                const validPhone = validatePhone(this.Assurhospi.Assure.Telephone);
                                this.errors.phone = validPhone.error;

                                const validEmail = validateEmail(this.Assurhospi.Assure.Email);
                                this.errors.email = validEmail.error;
                                if(validEmail.valide == true && validPhone.valide == true){
                                    if(this.Assurhospi.Assure.Cni){
                                        this.step = 4
                                        document.getElementById("testup").classList.add('widthThirt');
                                        document.getElementById("firstStep").classList.add('checked');
                                        this.nextStep2();
                                    }else {
                                        this.$toasted.show("CNI obligatoire! ", this.ToastTabError)
                                    }
                                }
                            }else {
                                this.$toasted.show('Téléphone et Email obligatoires! ', this.ToastTabError)
                                this.animation = 'animate-wrong';
                                setTimeout(() => {
                                    this.animation = '';
                                }, 400);
                            }
                       
                    }else {
                        this.$toasted.show('Date et lieu de naissance obligatoires! ', this.ToastTabError)
                    }
                } else {
                    this.$toasted.show('Nom et Prénom obligatoires! ', this.ToastTabError)
                }
            },

            BenefControl() {
                if (this.Assurhospi.Beneficiaire.Nom && this.Assurhospi.Beneficiaire.Prenom) {
                    if(this.Assurhospi.Beneficiaire.Filiation){
                        const Date18 = dayjs(this.Assurhospi.Beneficiaire.dateNaissance).add(+18, 'year').format('YYYY-MM-DD')
                        const dateToday = dayjs(new Date()).format('YYYY-MM-DD');

                        const DateDiff = dayjs(dateToday).diff(dayjs(Date18), 'year')
                        console.log("===== age beneficiaire=====", DateDiff)

                        if(DateDiff <= 0){
                            this.step = 5
                            document.getElementById("testup").classList.add('widthFive');
                            document.getElementById("secondStep").classList.add('checked');
                            this.nextStep3()
                        }else {
                            if(this.Assurhospi.Beneficiaire.Cni){
                                this.step = 5
                                document.getElementById("testup").classList.add('widthFive');
                                document.getElementById("secondStep").classList.add('checked');
                                this.nextStep3()
                            }else{
                                this.$toasted.show('Cni obligatoire! ', this.ToastTabError)
                            }
                        }
                    }else {
                        this.$toasted.show('Filiation obligatoire! ', this.ToastTabError)
                    }
                } else {
                    this.$toasted.show('Nom et Prénom obligatoires! ', this.ToastTabError)
                }
            },
            
            BackToBenefForm(){
                this.animation = 'animate-out-back';
                setTimeout(() => {
                    this.animation = 'animate-in-back';
                    this.activeStep -= 1;
                    this.e1 = 4;
                    this.isContractant = false,
                    this.isAssure = false,
                    this.isBenef = true
                }, 500);
            },

            validField() {
                    if(this.question_7.principal_response === 'oui'){
                        if(this.question_7.resp_date){
                            this.QuestionnaireTab.push(this.question_7)
                            this.step = 6
                            document.getElementById("testup").classList.add('widthFive');
                            document.getElementById("thirtStep").classList.add('checked');
                            this.nextStep4()
                            this.bottomPushNotif =false
                        }else {
                            this.$toasted.show("Champ obligatoire! ", this.ToastTabError)
                        }
                    } else if (this.question_7.principal_response === 'non'){
                        this.QuestionnaireTab.push(this.question_7)
                        this.step = 6
                            document.getElementById("testup").classList.add('widthFive');
                            document.getElementById("thirtStep").classList.add('checked');
                        this.nextStep4()
                        this.bottomPushNotif =false
                    }
            }
        }
    }
</script>

<style lang="less" scoped>
    @import "../../assets/css/button.css";
    @import "../../assets/css/devis_css.css";

::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  font-size: 15px;
}
.to-right {
  float: right!important;
}


    .form {
        background-color: #fff;
        padding: 1.5rem;
    }

    .form .page {
        height: auto;
    }

    button.next {
        position: absolute;
        bottom: 0;
        right: 0;
        margin-right: 1.5rem;
        margin-bottom: 1rem;
    }

    button.previous {
        position: absolute;
        bottom: 0;
        left: 0;
        margin-left: 1.5rem;
        margin-bottom: 1rem;
    }


    button.edit {
        position: absolute;
        bottom: 0;
        right: 0;
    }

    h4 {
        color: #29323a;
        margin-bottom: 15px;
        font-weight: 600;
    }




    html {
        background-color: #1a1a1a;
        overflow: hidden;
    }
    .middle {
        width: auto;
        text-align: center;
        /* Made by */
    }
    .middle h1 {
        font-family: "Inter", sans-serif;
        color: #fff;
    }
    .middle input[type="radio"] {
        display: none;
    }
    .middle input[type="radio"]:checked + .box {
        background-color: rgba(255, 164, 9, 0.07);
        transition: all .33s ease;
        border: 2px solid #ffa409;
        color: #29323a;
    }
    .middle input[type="radio"]:checked + .box span {
        color: #29323a;
        transform: translateY(70px);
    }
    .middle input[type="radio"]:checked + .box span:before {
        transform: translateY(0px);
        opacity: 1;
    }
    .middle .box {
        width: 220px;
        height: 150px;
        border-radius: 12px;
        background-color: #fff;
        transition: all 250ms ease;
        will-change: transition;
        display: inline-block;
        text-align: center;
        cursor: pointer;
        position: relative;
        box-shadow: 0 4px 8px rgb(172 186 200 / 10%);
        font-size: 10px;
        border: 1px solid #d9dee3;
        font-family: Open Sans,sans-serif;
        font-weight: 900;
    }
    .middle .box:hover {
        background-color: rgba(255, 164, 9, 0.07);
        transition: all .33s ease;
        border: 2px solid #ffa409;
    }
    .middle .box:hover span {
        color: #29323a;
    }

    .middle .box:active {
        transform: translateY(10px);
    }
    .middle .box span {
        position: absolute;
        transform: translate(0, 60px);
        left: 0;
        right: 0;
        padding-top: 15%;
        transition: all 300ms ease;
        font-size: 1.5em;
        user-select: none;
        color: #29323a;
    }
    .middle .box span:before {
        font-size: 1.2em;
        font-family: FontAwesome;
        display: block;
        transform: translateY(-80px);
        opacity: 0;
        transition: all 300ms ease-in-out;
        font-weight: normal;
        color: #fff;
    }
    .middle p {
        color: #fff;
        font-family: "Inter", sans-serif;
        font-weight: 400;
    }
    .middle p a {
        text-decoration: underline;
        font-weight: bold;
        color: #fff;
    }
    .middle p span:after {
        content: "\f0e7";
        font-family: FontAwesome;
        color: yellow;
    }

    .widthFirst{
        background-color: var(--custom-color-primary)!important;
        height: 5px;
        border-radius: 5px;
        transition: width .33s ease;
        width:23.55556%;
    }
    .widthSecond{
        background-color: var(--custom-color-primary)!important;
        height: 5px;
        border-radius: 5px;
        transition: width .33s ease;
        width:32.11112%;
    }
    .widthThirt{
        background-color: var(--custom-color-primary)!important;
        height: 5px;
        border-radius: 5px;
        transition: width .33s ease;
        width:40.11112%;
    }
    .widthFour{
        background-color: var(--custom-color-primary)!important;
        height: 5px;
        border-radius: 5px;
        transition: width .33s ease;
        width:50.11112%;
    }
    .widthFive{
        background-color: var(--custom-color-primary)!important;
        height: 5px;
        border-radius: 5px;
        transition: width .33s ease;
        width:65.11112%;
    }
    .widthSix{
        background-color: var(--custom-color-primary)!important;
        height: 5px;
        border-radius: 5px;
        transition: width .33s ease;
        width:100%;
    }

    .paralax-cover-image {
        background-image: url('../../assets/img/assurance/vie.jpg');
        position: relative;
        background-size: contain!important;
        background-position: 50%;
        min-height: 230px;
        width: 100%;
        margin: 0 0 0;
        display: flex;
        /*padding: 20px;*/
        align-items: center;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;

    }
    .paralax-cover-image p {
        color: rgb(255, 255, 255);
        font-size: 20px;
        font-weight: 300;
    }

    .paralax-cover-image .paralax-cover-image-text,
    .paralax-cover-image h2 {
        color: #fff;
        font-size: 2em;
        line-height: 1.25;
        z-index: 1;
        margin-bottom: 0;
        max-width: 610px;
        text-align: center;
        margin-left: 8.5%;
    }

    .paralax-cover-image.has-background-dim:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .paralax-cover-image {
        background-attachment: fixed;
        background-position: 50% 40px;
    }



    .paralax-cover-image_mobile {
        background-image: url('../../assets/img/assurance/vie_mobile.jpg');
        position: relative;
        background-size: contain;
        background-position: 50%;
        min-height: 150px;
        width: 100%;
        margin: 0 0 0;
        display: flex;
        //padding: 20px;
        align-items: center;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;

    }
    .paralax-cover-image_mobile p {
        color: rgb(255, 255, 255);
        font-size: 20px;
        font-weight: 300;
        padding-bottom: 20Px;
    }

    .paralax-cover-image_mobile .paralax-cover-image-text_mobile,
    .paralax-cover-image_mobile h2 {
        color: #fff;
        font-size: 2em;
        line-height: 1.25;
        z-index: 1;
        margin-bottom: 0;
        max-width: 610px;
        text-align: center;
        margin-left: 8.5%;
    }

    .paralax-cover-image_mobile.has-background-dim_mobile:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .paralax-cover-image_mobile {
        //background-attachment: fixed;
        background-position: 100% 40px;
    }


    .hero {
        position: relative;
        background-size: cover;
        background-position: center center;
        height: 680px;
        min-height: 320px;
        max-height: 100%;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;
        align-items: center;
        -webkit-justify-content: center;
        -moz-justify-content: center;
        -ms-justify-content: center;
        justify-content: center;
        -ms-flex-pack: center;
        padding: 20px;
    }
    .hero .content_home {
        position: relative;
        min-height: 280px;
        width: 100%;
        margin-left: 8.5%;
        z-index: 2;
        /*//background: red;*/
    }
    .hero .content_home p {
        color: rgb(255, 255, 255);
        font-size: 20px;
        font-weight: 300;
        width: 100%;
        max-width: 100%;
        margin-left: auto;
        margin-right: auto;
    }

    .to-left {
  text-align: left;
}

  // css du loader
.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  
}
.loading {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 5px solid #ddd;
  border-top-color: #ffa409;
  animation: loading 1s linear infinite;
}
@keyframes loading {
  to {
    transform: rotate(360deg);
  }
}
.loading-text{
    color: rgb(255, 255, 255);
    font-weight: bold;
}

</style>
